export const USER_RATING = {
  RATING_BODY_HEADER: 'Enjoying XomePro?',
  RATING_BODY_TEXT: 'Would you mind giving us a review in the App Store?',
  APP_STORE_URL: 'https://apps.apple.com/in/app/xomepro/id1403339870',
  PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.xomepro.xome',
  SHOW_USER_RATING_POPUP: 'showuserrating'
};
